export const passengerTypeMap = {
  'ADT': 'ADULT',
  'CHD': 'CHILD',
  'INF': 'INFANT',
  'MWD': 'MWD',
  'PWD': 'PWD'
}

export const serviceClassMap = {
  Y: '经济舱',
  C: '公务舱',
  W: '经济舱'
}
